(function () {
  'use strict';

  angular
    .module('flightDelayReport')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('flightDelayReport', {
        url: '/flight-delay-report',
        views: {
        	'flightDelayReportView' : {
        		templateUrl: 'flight-delay-report/views/flight-delay-report.tpl.html',
                controller: 'FlightDelayReportCtrl',
                controllerAs: 'flightDelayReport'
        	}
        }
      });
  }
}());
